import Vue from 'vue'
// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    //弹框可拉伸最小宽高
    let minWidth = 500;
    let minHeight = 400;
    //初始非全屏
    let isFullScreen = false;
    //当前宽高
    let nowWidth = 0;
    let nowHight = 0;
    //当前顶部高度
    let nowMarginTop = 0;
    //获取弹框头部（这部分可双击全屏）
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    console.log('dialogHeaderEl', dialogHeaderEl)
    //弹窗
    const dragDom = el.querySelector('.el-dialog');
    //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    //@ts-ignore
    dragDom.style.overflow = "auto";
    //清除选择头部文字效果
    //@ts-ignore
    dialogHeaderEl.onselectstart = new Function("return false");  
    //头部加上可拖动cursor
    //@ts-ignore
    dialogHeaderEl.style.cursor = 'move';
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    //@ts-ignore
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
    //@ts-ignore
    let moveDown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      //@ts-ignore
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      //@ts-ignore
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      // 获取到的值带px 正则匹配替换
      //@ts-ignore
      let styL, styT;
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/px/g, '');
        styT = +sty.top.replace(/px/g, '');
      };
      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离 
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        // 移动当前元素 
        //@ts-ignore 
        dragDom.style.left = `${l + styL}px`;
        //@ts-ignore
        dragDom.style.top = `${t + styT}px`;
        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };



      var dom = null;
    var observer = null;
    var interval = setTimeout(function () {
      dom = document.querySelector(
        ".el-dialog"
      );
      // console.log('dom', dom[0])
      if (dom) {
        console.log("计时");
        // @ts-ignore
        var MutationObserver =window.MutationObserver ||window.WebKitMutationObserver ||window.MozMutationObserver;
        let elementAll = document.querySelectorAll(".el-dialog");
        console.log('elementAll', elementAll)
        for (let i = 0; i < elementAll.length; i++) {
          let element = document.querySelectorAll(".el-dialog")[i];
          console.log('element', element)
          observer = new MutationObserver((mutationList) => {
            let top = getComputedStyle(element).getPropertyValue("top");
            let left = getComputedStyle(element).getPropertyValue("left");
            // @ts-ignore
            const leftMax =parseFloat(document.documentElement.getBoundingClientRect().width) - element.getBoundingClientRect().width;
            // @ts-ignore
            const topMax =parseFloat(document.documentElement.getBoundingClientRect().height) - element.getBoundingClientRect().height;
            if (top[0] == "-") {
              // @ts-ignore
              element.style.top = "2px";
            }
            if (left[0] == "-") {
              // @ts-ignore
              element.style.left = "2px";
            }
            if (parseFloat(left) > leftMax) {
              // @ts-ignore
              element.style.left = leftMax + "px";
            }
            if (topMax < 0) {
              if (parseFloat(top) > -topMax) {
                // @ts-ignore
                element.style.top = -topMax + "px";
              }
            } else {
              if (parseFloat(top) > topMax) {
                // @ts-ignore
                element.style.top = topMax + "px";
              }
            }
          });
          observer.observe(element, {
            attributes: true,
            attributeFilter: ["style"],
            attributeOldValue: true,
          });
        }
      }
    }, 10);
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
    //@ts-ignore
    dialogHeaderEl.onmousedown = moveDown;
    //双击头部效果
    //@ts-ignore
    dialogHeaderEl.ondblclick = (e) => {
      if (isFullScreen == false) {
        //@ts-ignore
        nowHight = dragDom.clientHeight;
        //@ts-ignore
        nowWidth = dragDom.clientWidth;
        //@ts-ignore
        nowMarginTop = dragDom.style.marginTop;
        //@ts-ignore
        dragDom.style.left = 0;
        //@ts-ignore
        dragDom.style.top = 0;
        //@ts-ignore
        dragDom.style.height = "100VH";
        //@ts-ignore
        dragDom.style.width = "100VW";
        //@ts-ignore
        dragDom.style.marginTop = 0;
        //@ts-ignore
        isFullScreen = true;
        //@ts-ignore
        dialogHeaderEl.style.cursor = 'initial';
        //@ts-ignore
        dialogHeaderEl.onmousedown = null;
      } else {
        //@ts-ignore
        dragDom.style.height = "auto";
        //@ts-ignore
        dragDom.style.width = nowWidth + 'px';
        //@ts-ignore
        dragDom.style.marginTop = nowMarginTop;
        //@ts-ignore
        isFullScreen = false;
        //@ts-ignore
        dialogHeaderEl.style.cursor = 'move';
        //@ts-ignore
        dialogHeaderEl.onmousedown = moveDown;
      }
    }
    
    // //拉伸(右下方)
    // let resizeEl=document.createElement("div");
    // //@ts-ignore
    // dragDom.appendChild(resizeEl); 
    // //在弹窗右下角加上一个10-10px的控制块
    // resizeEl.style.cursor = 'se-resize';
    // resizeEl.style.position = 'absolute';
    // resizeEl.style.height = '10px';
    // resizeEl.style.width = '10px';
    // resizeEl.style.right = '0px';
    // resizeEl.style.bottom = '0px';
    // resizeEl.style.zIndex = '99';
    // //鼠标拉伸弹窗
    // resizeEl.onmousedown = (e) => {
    //   // 记录初始x位置
    //   let clientX = e.clientX;
    //   // 鼠标按下，计算当前元素距离可视区的距离
    //   let disX = e.clientX - resizeEl.offsetLeft;
    //   let disY = e.clientY - resizeEl.offsetTop;
    //   document.onmousemove = function (e) {
    //     e.preventDefault(); // 移动时禁用默认事件
        
    //     // 通过事件委托，计算移动的距离
    //     let x = e.clientX - disX + (e.clientX - clientX);//这里 由于elementUI的dialog控制居中的，所以水平拉伸效果是双倍
    //     let y = e.clientY - disY;
    //     //比较是否小于最小宽高
    //     //@ts-ignore
    //     dragDom.style.width = x > minWidth ? `${x}px` : minWidth + 'px';
    //     //@ts-ignore
    //     dragDom.style.height = y > minHeight ? `${y}px` : minHeight + 'px';
    //     };
    //   //拉伸结束
    //   document.onmouseup = function (e) {
    //     document.onmousemove = null;
    //     document.onmouseup = null;
    //   };
    // }
    
    //拉伸(右边)
    let resizeElR=document.createElement("div");
    //@ts-ignore
    dragDom.appendChild(resizeElR); 
    //在弹窗右下角加上一个10-10px的控制块
    resizeElR.style.cursor = 'w-resize';
    resizeElR.style.position = 'absolute';
    resizeElR.style.height = '100%';
    resizeElR.style.width = '10px';
    resizeElR.style.right = '0px';
    resizeElR.style.top = '0px';
    //鼠标拉伸弹窗
    resizeElR.onmousedown = (e) => {
      //@ts-ignore
      let elW = dragDom.clientWidth;
      //@ts-ignore
      let EloffsetLeft = dragDom.offsetLeft;
      // 记录初始x位置
      let clientX = e.clientX;
      document.onmousemove = function (e) {
        e.preventDefault(); // 移动时禁用默认事件
        //右侧鼠标拖拽位置
        if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {
            //往左拖拽
            if (clientX > e.clientX) {
              //@ts-ignore
                if (dragDom.clientWidth < minWidth) {
                } else {
                  //@ts-ignore
                    dragDom.style.width = elW - (clientX - e.clientX) + 'px';
                }
            }
            //往右拖拽
            if (clientX < e.clientX) {
              //@ts-ignore
                dragDom.style.width = elW + (e.clientX - clientX) + 'px';
            }
        }
       
      };
      //拉伸结束
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
    
    //拉伸(左边)
    let resizeElL=document.createElement("div");
    //@ts-ignore
    dragDom.appendChild(resizeElL); 
    //在弹窗右下角加上一个10-10px的控制块
    resizeElL.style.cursor = 'w-resize';
    resizeElL.style.position = 'absolute';
    resizeElL.style.height = '100%';
    resizeElL.style.width = '10px';
    resizeElL.style.left = '0px';
    resizeElL.style.top = '0px';
    //鼠标拉伸弹窗
    resizeElL.onmousedown = (e) => {
      //@ts-ignore
      let elW = dragDom.clientWidth;
      //@ts-ignore
      let EloffsetLeft = dragDom.offsetLeft;
      // 记录初始x位置
      let clientX = e.clientX;
      document.onmousemove = function (e) {
        e.preventDefault(); // 移动时禁用默认事件
        //左侧鼠标拖拽位置
        if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
            //往左拖拽
            if (clientX > e.clientX) {
              //@ts-ignore
                dragDom.style.width = elW + (clientX - e.clientX) + 'px';
            }
            //往右拖拽
            if (clientX < e.clientX) {
              //@ts-ignore
                if (dragDom.clientWidth < minWidth) {
                } else {
                  //@ts-ignore
                    dragDom.style.width = elW - (e.clientX - clientX) + 'px';
        
                }
            }
        }
       
      };
      //拉伸结束
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
    
    // // 拉伸(下边)
    let resizeElB=document.createElement("div");
    //@ts-ignore
    dragDom.appendChild(resizeElB); 
    //在弹窗右下角加上一个10-10px的控制块
    resizeElB.style.cursor = 'n-resize';
    resizeElB.style.position = 'absolute';
    resizeElB.style.height = '10px';
    resizeElB.style.width = '100%';
    resizeElB.style.left = '0px';
    resizeElB.style.bottom = '0px';
    //鼠标拉伸弹窗
    resizeElB.onmousedown = (e) => {
      //@ts-ignore
     let EloffsetTop = dragDom.offsetTop;
     let ELscrollTop = el.scrollTop;
      let clientY = e.clientY;
      //@ts-ignore
      let elH = dragDom.clientHeight;
      // console.log('el.scrollTop',el.scrollTop)
      // console.log('e.clientY', e.clientY)
      // console.log('dragDom.offsetTop', dragDom.offsetTop)
      // console.log(ELscrollTop + clientY > EloffsetTop + elH - 110 )
      // console.log(ELscrollTop + clientY < EloffsetTop + elH + 55 )

      document.onmousemove = function (e) {
        e.preventDefault(); // 移动时禁用默认事件
        //底部鼠标拖拽位置
        if (ELscrollTop + clientY > EloffsetTop + elH - 110 && ELscrollTop + clientY < EloffsetTop + elH + 55) {
            //往上拖拽
            if (clientY > e.clientY) {
              //@ts-ignore
                if (dragDom.clientHeight < minHeight) {
                } else {
                  //@ts-ignore
                    
                }
                //@ts-ignore
                dragDom.style.height = elH - (clientY - e.clientY) + 'px';
            }
            //往下拖拽
            if (clientY < e.clientY) {
              //@ts-ignore
                dragDom.style.height = elH + (e.clientY - clientY) + 'px';
            }
        }
      };
      //拉伸结束
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
})